import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash2, Columns, Rows, GripVertical, Pencil } from 'lucide-react';
import { SplitPatternPicker } from './SplitPatternPicker';
import { SplitPattern, canSplit, GridCell } from './types';

interface CellToolbarProps {
  cell: GridCell;
  onEdit: () => void;
  onSplitHorizontal: (pattern: SplitPattern) => void;
  onSplitVertical: (pattern: SplitPattern) => void;
  onDelete: () => void;
  className?: string;
}

export const CellToolbar: React.FC<CellToolbarProps> = ({
  cell,
  onEdit,
  onSplitHorizontal,
  onSplitVertical,
  onDelete,
  className = '',
}) => {
  const canCellSplit = canSplit(cell);
  const hasContent = cell.content !== null;

  return (
    <div className={`flex items-center gap-0.5 bg-background border rounded-md shadow-sm p-0.5 ${className}`}>
      {hasContent && (
        <Button
          variant="ghost"
          size="sm"
          className="h-6 w-6 p-0"
          onClick={onEdit}
          title="Edit content"
        >
          <Pencil className="h-3 w-3" />
        </Button>
      )}
      
      <SplitPatternPicker
        direction="horizontal"
        onSelect={onSplitHorizontal}
        disabled={!canCellSplit}
      >
        <Button
          variant="ghost"
          size="sm"
          className="h-6 w-6 p-0"
          disabled={!canCellSplit}
          title={canCellSplit ? 'Split into columns' : 'Maximum depth reached'}
        >
          <Columns className="h-3 w-3" />
        </Button>
      </SplitPatternPicker>
      
      <SplitPatternPicker
        direction="vertical"
        onSelect={onSplitVertical}
        disabled={!canCellSplit}
      >
        <Button
          variant="ghost"
          size="sm"
          className="h-6 w-6 p-0"
          disabled={!canCellSplit}
          title={canCellSplit ? 'Split into rows' : 'Maximum depth reached'}
        >
          <Rows className="h-3 w-3" />
        </Button>
      </SplitPatternPicker>
      
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 text-destructive hover:text-destructive"
        onClick={onDelete}
        title="Delete cell"
      >
        <Trash2 className="h-3 w-3" />
      </Button>
    </div>
  );
};
